<template>
  <div class="Gyfybox">
    <GYFY />
  </div>
</template>
<script>
import GYFY from "@/components/GYFY.vue";
export default {
  components: { GYFY },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Gyfybox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>